<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="sms icon"></i>
      {{ $t("sms configuration") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/sms.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form">
          <div class="fields">
            <div class="eight column wide field">
              <label>{{ $t("name") }}</label>
              <input type="text" name="name" placeholder="" v-model="name" />
            </div>
            <div class="four column wide field">
              <label>{{ $t("provider") }}</label>
              <div class="ui selection dropdown" ref="provider_dropdown">
                <input type="hidden" name="provider" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="">
                    {{ $t("select one") }}
                  </div>
                  <div class="item" data-value="grupo_gente">
                    {{ $t("grupo gente") }}
                  </div>
                  <!-- <div class="item" data-value="mandrill">
                    {{ $t("mandrill") }}
                  </div>
                  <div class="item" data-value="outlook">
                    {{ $t("outlook") }}
                  </div> -->
                </div>
              </div>
            </div>
            <div class="four column wide field">
              <div class="ui toggle checkbox" ref="is_default">
                <input type="checkbox" class="hidden" />
                <label>{{ $t("is default") }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="ui dividing header" v-if="provider">
          {{ $t("provider info") }}
        </div>
        <grupo-gente
          :selected_configuration="selected_configuration"
          ref="grupo_gente"
          v-if="provider == 'grupo_gente'"
        />
        <!-- <mandrill
          :selected_configuration="selected_configuration"
          ref="mandrill"
          v-if="provider == 'mandrill'"
        />
        <outlook
          :selected_configuration="selected_configuration"
          ref="outlook"
          v-if="provider == 'outlook'"
        /> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import GrupoGente from "./GrupoGente.vue";
// import Outlook from "./Outlook.vue";
// import Mandrill from "./Mandrill.vue";

export default {
  name: "EmailModal",
  filters: filters,
  components: {
    GrupoGente,
    // Mandrill,
    // Outlook,
  },
  computed: {},
  props: { selected_configuration: Object },
  data() {
    return {
      name: "",
      is_default: false,
      provider: "",
      setup: {},
    };
  },
  methods: {
    show(config) {
      let vm = this;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            vm.name = "";
            vm.is_default = false;
            vm.provider = "";
            vm.setup = {};
          },
        })
        .modal("show");

      if (config) console.log(config);
    },
    save() {
      let vm = this;
      let setup = {};
      if (vm.provider == "grupo_gente") setup = vm.$refs.grupo_gente.getSetup();
      // else if (vm.provider == "mandrill") setup = vm.$refs.mandrill.getSetup();
      // else if (vm.provider == "outlook") setup = vm.$refs.outlook.getSetup();
      setup.provider = vm.provider;
      local_api(vm, "post", "/settings/messaging/do-save-sms", {
        i: vm.selected_configuration
          ? vm.selected_configuration.uuid
          : undefined,
        s: setup,
        n: vm.name,
        d: vm.is_default,
      })
        .then(() => {
          window.jQuery(vm.$refs.modal).modal("hide");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    // finished() {
    //   let vm = this;
    //   return new Promise(function(resolve, reject) {
    //     let setup = {};
    //     if (vm.provider == "nodemailer") setup = vm.$refs.nodemailer.getSetup();
    //     else if (vm.provider == "mandrill")
    //       setup = vm.$refs.mandrill.getSetup();
    //     else if (vm.provider == "outlook") setup = vm.$refs.outlook.getSetup();
    //     setup.provider = vm.provider;
    //     local_api(vm, "post", "/settings/messaging/do-save-email", {
    //       i: vm.selected_configuration
    //         ? vm.selected_configuration.uuid
    //         : undefined,
    //       s: setup,
    //       n: vm.name,
    //       d: vm.is_default,
    //     })
    //       .then((r) => {
    //         vm.$emit("succedded", r);
    //         resolve(r);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
    // destroy() {
    //   this.$emit("destroy");
    //   this.$destroy();
    // },
  },
  created() {},
  mounted() {
    let vm = this;

    /**
     * Init checkebox
     */
    window.jQuery(vm.$refs.is_default).checkbox({
      onChange() {
        vm.is_default = window
          .jQuery(vm.$refs.is_default)
          .checkbox("is checked");
      },
    });

    /**
     * Dropdown initialization
     */
    window.jQuery(vm.$refs.provider_dropdown).dropdown({
      onChange(value) {
        vm.provider = value;
      },
    });

    /**
     * Set stored values
     */
    if (vm.selected_configuration) {
      vm.name = vm.selected_configuration.name;
      if (vm.selected_configuration.setup.provider)
        window
          .jQuery(vm.$refs.provider_dropdown)
          .dropdown("set selected", vm.selected_configuration.setup.provider);
      if (vm.selected_configuration.is_default)
        window.jQuery(vm.$refs.is_default).checkbox("set checked");
    }
  },
  watch: {},
};
</script>
